export default __webpack_public_path__ + "static/media/youtube.b73c9285.svg";